// define global variables for ESLint
/* global tinymce */

$(document).ready(function () {
    if ($('.course-item.current').length > 0 && $('.course-curriculum').length > 0)
    $('.course-curriculum').animate({
        scrollTop: $('.course-item.current:first').offset().top - 200
    }, 1000);
    $('.screen-reader-shortcut').attr('tabindex', 0);
});


const cookieFunctions = require('./cookies');
const getCookie = cookieFunctions.getCookie;

(function ($) {
    $(function () {
        $('.em-booking-form').addClass('wpcf7');
        $('.em-booking-form .em-booking-submit').addClass('btn');
        $('.em-booking-form input:not([type=checkbox]), .em-booking-form select, .em-booking-form textarea').css({
            'width': '100%',
            'padding': '.5em',
            'border-style': 'solid;',
            'border-color': '#808080;',
            'border-width': '1px;',
            'margin-bottom': '1em;'
        });
        $('.em-booking-form .input-field-data_privacy_consent label').css({'padding-left': '2em'});
        $('.em-booking-form .em-booking-form-details').css({width: '100%'});

        $('.em-booking-login').addClass('wpcf7').css({
            'padding': '2rem 0 0 0',
            'margin': '0',
            'border': '0',
            'borderTop': '1px solid #000'
        });
        $('#em_wp-submit').addClass('btn').css({'width': '100%', 'padding': '0.5em', 'overflow': 'hidden'});
        $('#em_rememberme').css({'position': 'relative', 'top': '0'});
        $('div.em-booking-login label').css({'width': '85%'});


        setTimeout(function () {
            $('#pg-10674-0 + .p-wrap').wrap('<div style="background: white">');
        }, 100);

        $('.curriculum-sections li.section').addClass('open');
        $('.curriculum-sections li.section .section-header').on('click', function () {
            capito_lp_section_highlight($(this).closest('li.section'));
        });

        $('.curriculum-sections .status-evaluated.bestanden .course-item-meta i.fa').addClass('fa-check');
        $('.curriculum-sections .status-completed.passed .course-item-meta i.fa').addClass('fa-check');
        $('.curriculum-sections .course-item-lp_assignment.status-completed .course-item-meta i.fa').addClass('fa-check');
        $('.curriculum-sections .status-started .course-item-meta i.fa').addClass('fa-clock');
        $('.curriculum-sections .has-status.status-completed.failed .course-item-meta i.fa').addClass('fa-times');


        let state = getCookie('contrast');
        const isContrast = state == 'true';

        if (isContrast) {
            $('body').addClass('contrast');
            (function () {
                let styles = document.createElement('link');
                styles.rel = 'stylesheet';
                styles.type = 'text/css';
                styles.media = 'screen';
                styles.href = '/app/themes/love-it/assets/scss/style.ally.css?v=1.2';
                document.getElementsByTagName('head')[0].appendChild(styles);
            })();
        }

        $('ul.question-numbers li a').each(function () {
            let active = parseInt($(this).closest('ul').find('> li.current a').text());
            let thisa = parseInt($(this).text());
            if (thisa == active) {
                $(this).attr('disabled', 'disabled').css({'pointer-events': 'none'});
            } else if (thisa > active) {
                $(this).attr('disabled', 'disabled').css({
                    'pointer-events': 'none',
                    'color': '#ccc',
                    'background': '#efefef'
                });
            }
        });

        $('body').on('click', 'ul.question-numbers li a', function (e) {
            let active = parseInt($(this).closest('ul').find('> li.current a').text());
            let clicked = parseInt($(this).text());

            if (clicked >= active) {
                e.preventDefault();
                e.stopPropagation();
            }
        });

        $('body').attr('data-font-size', localStorage.getItem('font') || 0);
    });


    // Was needed a timeout since RTE is not initialized when this code run.
    let updatemce = function () {
        if (!window.tinymce) return;

        let assignemntseditor = 'assignment-editor-frontend';
        if (!tinymce.editors[assignemntseditor]) return;

        updatemce = function () {
        };

        tinymce.editors[assignemntseditor].on('NodeChange keyup', function (ed, e) {
            // Update HTML view textarea (that is the one used to send the data to server).
            tinymce.editors[assignemntseditor].save();
            $('textarea#' + assignemntseditor).trigger('change');
        });

        $('textarea#' + assignemntseditor).change(function () {
            let val = $(this).val();
            let sbmtbtn = $(this).closest('form').find('button[type="submit"][value="Send"]');
            let savebtn = $(this).closest('form').find('button[type="submit"][value="Save"]');
            if (!sbmtbtn.attr('data-orig')) {
                sbmtbtn.attr('data-orig', sbmtbtn.html());
                savebtn.attr('data-orig', savebtn.html());
            }
            if (val) {
                sbmtbtn.attr('disabled', null);
                sbmtbtn.html(sbmtbtn.attr('data-orig'));
                savebtn.attr('disabled', null);
                savebtn.html(savebtn.attr('data-orig'));
            } else {
                sbmtbtn.attr('disabled', 'disabled');
                sbmtbtn.html('Bitte zuerst eine Antwort eingeben!');
                savebtn.attr('disabled', 'disabled');
                savebtn.html('Bitte zuerst eine Antwort eingeben!');
            }
        }).change();
    }

    setTimeout(updatemce, 3000);
    $(function () {
        if ($('form[name="save-assignment"]').length && !$('link[href~="editor.css"]').length) {
            $('<link rel="stylesheet" id="editor-buttons-css" href="https://www.capito-international.com/wp-includes/css/editor.css?ver=5.5.3" type="text/css" media="all">').appendTo('head');
            $('<link rel="stylesheet" id="dashicons-css" href="https://www.capito-international.com/wp-includes/css/dashicons.css?ver=5.5.3" type="text/css" media="all">').appendTo('head');
        }
    });

    $(document).on('submit_success', function (e) {
        let form_id = $(e.target).attr('id');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'elementor_form_success',
            'formId': form_id
        });
    });
})(jQuery);

function capito_lp_section_highlight(section) {
    let visible = section.find('.section-content').is(':visible')
    if (visible) {
        section.removeClass('open');
    } else {
        section.addClass('open');
    }
}

jQuery.fn.extend({
    live: function (event, callback) {
        if (this.selector) {
            jQuery(document).on(event, this.selector, callback);
        }
        return this;
    }
});

